import axios, { AxiosStatic } from "axios";

import { OrgLevel } from "../../model";

export class OrgStructureApi {

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async getAll(parentId: string | undefined): Promise<OrgLevel[]> {
        const response = await this.axios.get("/api/orgstructure", { params: parentId ? { parentId } : {} });
        const model = response.data as OrgLevel[];
        return model;
    }
}

export const orgStructureApi = new OrgStructureApi(axios);
